import React from "react";
import PropTypes from "prop-types";

export function Wrapper(props) {
  return (
    <div className={props.className} {...props}>
      {props.children}
    </div>
  );
}

Wrapper.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};
